/*
jQuery(document).ready(function ($) {
    $.fn.resizeLargeQuote = function () {
        this.children().children().css('height', '100%');
        this.children().css('height', '125%');

        //this.height(this.height() * 1.25);
        this.children().children().height(this.height());
        this.children().height(this.height() * 1.25);
        return this;
    }

    const largeQuote = $('.large-quote');

    largeQuote.resizeLargeQuote();

    $(window).on('resize', function (event) {
        largeQuote.resizeLargeQuote();
    });
});

 */